import { Component, Input, OnInit } from '@angular/core';
import { SharedService } from 'src/services/shared.service';

@Component({
  selector: 'app-gtinl2sd',
  templateUrl: './gtinl2sd.component.html',
  styleUrls: ['./gtinl2sd.component.scss']
})
export class Gtinl2sdComponent implements OnInit {

  @Input() gtinAttribute: any;
  linkTypes: any = [];
  constructor(private sharedService: SharedService) { }

  ngOnInit(): void {
    const response = this.sharedService.getLinkTypes();
    this.linkTypes = response.sort(this.compare);   

    const languageMap = {};
    const languageLookup = JSON.parse(localStorage.getItem('languages') || '[]');
    languageLookup.forEach(lang => {
      if (lang.alpha2) languageMap[lang.alpha2] = lang.translation || lang.name;
      if (lang.alpha3) languageMap[lang.alpha3] = lang.translation || lang.name;      
    });

    this.gtinAttribute?.linkset?.forEach(item => {
      Object.keys(item).forEach(key => {
        const value = item[key];
        if (Array.isArray(value)) {
          value.forEach(innerObj => {
            if (innerObj.hreflang) {
              innerObj.hrefLangFullName = innerObj.hreflang.map(code => languageMap[code] || code);
            }
          });
        }
      });
    });

  }  

  compare(current, next) {
    if (current.linkTypeName < next.linkTypeName) {
      return -1;
    }
    if (current.linkTypeName > next.linkTypeName) {
      return 1;
    }
    return 0;
  }

}
